import React from 'react';
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomDrawer from "../../components/CustomDrawer";
import { useTranslation } from 'react-i18next';
import { dataUtil } from '../../services/wsclients/dataUtil';
import { BackRightIcon, LowFontIcon, UpFontIcon } from '../../components/CustomIcons';
import { makeStyles } from '@mui/styles';
import { formatDateToDDMMYYYYFrEpoch } from '../../utils/commons';
import CustomRadioButtonGroup from '../../components/CustomRadioButtonGroup';

const useStyles = makeStyles((theme) => ({
    content: {
        margin: theme.spacing(3, 0),
    },
    service: {
        padding: theme.spacing(3),
        borderRadius: theme.spacing(3),
        backgroundColor: theme.palette.common.white,
    },
    service_icon: {
        textAlign: 'right',
        // backgroundColor: theme.palette.background.primary,
    },
    service_item: {
        cursor: 'pointer',
        justifyContent: 'center',
        textAlign: 'center',
    },
    invoicing: {
        margin: theme.spacing(2, 0),
    },
    invoicing_detail: {
        backgroundColor: theme.palette.common.white,
        padding: theme.spacing(3),
        borderRadius: theme.spacing(3),
    },
    select_date: {
        backgroundColor: theme.palette.common.white,
        padding: theme.spacing(3),
        borderRadius: theme.spacing(3),
        margin: theme.spacing(3, 0)
    },
}));

export default function ServiceDetailView(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    const { open, onClose, currency, service, onChangeService, dates, selectedDate, setSelectedDate, action, serviceChangeSelected, subscriptionSelected } = props;
    console.log("service===", service);
    let service_delivery_estimate = service && service.service_delivery_estimate && service.service_delivery_estimate.length > 0 ? service.service_delivery_estimate[0] : null;
    let service_to_change = service_delivery_estimate && service_delivery_estimate.services_to_change && service_delivery_estimate.services_to_change.length > 0 ? service_delivery_estimate.services_to_change[0] : [];
    // let serviceFrom = service_to_change && service_to_change.product ? service_to_change.product : null;
    let serviceFrom = subscriptionSelected && subscriptionSelected.service && subscriptionSelected.service.product ? subscriptionSelected.service.product : null
    // let serviceTo = service_to_change && service_to_change.change_to_product ? service_to_change.change_to_product : null;
    let invoicing = service_delivery_estimate && service_delivery_estimate.billing_estimate && service_delivery_estimate.billing_estimate.invoicing && service_delivery_estimate.billing_estimate.invoicing.length > 0 ? service_delivery_estimate.billing_estimate.invoicing[0] : null;
    let family = service && service.service_to_change_detail && service.service_to_change_detail.family ? service.service_to_change_detail.family : null
    let showSectionDates = true;
    if(serviceFrom && serviceFrom.family && serviceFrom.family.name === 'Recurring service' && family && family.name === 'Recurring service'){
        showSectionDates = false;
    }
    if(serviceChangeSelected && !serviceChangeSelected.price){
        if(serviceChangeSelected.prices && serviceChangeSelected.prices.length > 0){
            serviceChangeSelected.price = parseFloat(serviceChangeSelected.prices[0].price)
        }
    }
    console.log("family===", family);
    console.log("serviceFrom===", serviceFrom);
    console.log("serviceChangeSelected===", serviceChangeSelected);

    return (
        <CustomDrawer
            open={open}
            title={service && service.name ? service.name : t('services')}
            onClose={onClose}
        >
            <Grid item xs={12} className={classes.content}>
                <Grid item xs={12}>
                    <Grid item xs={12} container spacing={1} alignItems='center' className={classes.service_item}>
                        <Grid item xs={5}>
                            <Grid item xs={12} className={classes.service}>
                                <Grid item xs={12} className={classes.service_item}>
                                    <Typography>{serviceFrom && serviceFrom.name ? serviceFrom.name : null}</Typography>
                                    <Typography variant="body2">{currency}{serviceFrom && serviceFrom.price ? serviceFrom.price.toFixed(2) : "0.00"}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={2}>
                            <BackRightIcon />
                        </Grid>
                        <Grid item xs={5}>
                            <Grid item xs={12} className={classes.service}>
                                <Grid item xs={12} className={classes.service_item}>
                                    <Typography>{serviceChangeSelected && serviceChangeSelected.name ? serviceChangeSelected.name : null}</Typography>
                                    <Typography variant="body2">{currency}{serviceChangeSelected && serviceChangeSelected.price ? serviceChangeSelected.price.toFixed(2) : "0.00"}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {showSectionDates && <Grid item xs={12} className={classes.select_date}>
                        <Grid item xs={12} marginTop={1}>
                            <Typography variant='body2' className={classes.text}>{t('please_choose_date')}</Typography>
                        </Grid>
                        <Grid item xs={12} marginTop={1}>
                            <CustomRadioButtonGroup
                                items={dates}
                                selected={selectedDate ? selectedDate : null}
                                onChange={(e) => setSelectedDate(e.target.value)}
                            />
                        </Grid>
                    </Grid>}
                    {/* {invoicing && <Grid item xs={12} className={classes.invoicing}>
                        <Grid item xs={12} className={classes.invoicing_detail}>
                            <Typography variant='h6' style={{ marginBottom: 10 }}>{t('invoicing')}</Typography>
                            <Grid item xs={12} container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography>{t('amount_due')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography>{currency}{invoicing.amount_due ? invoicing.amount_due.toFixed(2) : "0.00"}</Typography>
                                </Grid>
                            </Grid>
                            {invoicing.amount_to_collect > 0 && <Grid item xs={12} container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography>{t('amount_to_collect')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography>{currency}{invoicing.amount_to_collect.toFixed(2)}</Typography>
                                </Grid>
                            </Grid>}
                            {invoicing.due_date && <Grid item xs={12} container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography>{t('bill_due_date')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography>{formatDateToDDMMYYYYFrEpoch(invoicing.due_date)}</Typography>
                                </Grid>
                            </Grid>}
                            {invoicing.wallet_funds_amount > 0 && <Grid item xs={12} container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography>{t('wallet_funds_amount')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography>{currency}{invoicing.wallet_funds_amount.toFixed(2)}</Typography>
                                </Grid>
                            </Grid>}
                            <Grid item xs={12} container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography>{t('total_price')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography>{currency}{invoicing.total_price ? invoicing.total_price.toFixed(2) : "0.00"}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography>{t('total_tax_amount')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography>{currency}{invoicing.total_tax_amount ? invoicing.total_tax_amount.toFixed(2) : "0.00"}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography>{t('total_discount_amount')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography>{currency}{invoicing.total_discount_amount ? invoicing.total_discount_amount.toFixed(2) : "0.00"}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography>{t('total_discount_incl_tax')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography>{currency}{invoicing.total_discount_incl_tax ? invoicing.total_discount_incl_tax.toFixed(2) : "0.00"}</Typography>
                                </Grid>
                            </Grid>
                            <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                            <Grid item xs={12} container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography>{t('total_net_amount')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant='body2'>{currency}{invoicing.total_net_amount ? invoicing.total_net_amount.toFixed(2) : "0.00"}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography>{t('total_amount')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant='body2'>{currency}{invoicing.total_amount ? invoicing.total_amount.toFixed(2) : "0.00"}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>} */}
                    <Grid item xs={12} marginTop={5}>
                        <Grid item xs={12} textAlign='center'>
                            <Button variant='contained' color="info" size='small' onClick={() => onClose()}>{t('btn_back')}</Button>
                            <Button variant='contained' color="info" size='small' onClick={() => onChangeService()} style={{ marginLeft: 10 }}>{action === 'UPGRADE' ? t("upgrade") : t('downgrade')}</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </CustomDrawer>
    )
}